import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'

import '../../css/common/Switch.css';

class Switch extends Component {

  render() {
    const switchState = this.props.on === true ? true : false;
    const small = this.props.small === true ? true : false;
    const containerBackgroundColor = switchState ? '#1dc2ff' : '#e7e7e7';
    const containerContentJustification = switchState ? 'flex-end' : 'flex-start';

    const containerStyle = { width: 45, height: 30, borderRadius: 15, justifyContent: containerContentJustification, alignItems: 'center', backgroundColor: '#1dc2ff', paddingLeft: 2, paddingRight: 2, backgroundColor: containerBackgroundColor };
    const switchStype = { height: 26, width: 26, borderRadius: 13, backgroundColor: 'white' };

    const smallContainerStyle = { width: 35, height: 20, borderRadius: 15, justifyContent: containerContentJustification, alignItems: 'center', backgroundColor: '#1dc2ff', paddingLeft: 2, paddingRight: 2, backgroundColor: containerBackgroundColor }
    const smallSwitchStype = { height: 16, width: 16, borderRadius: 13, backgroundColor: 'white' };

    const onClick = this.props.onClick;

    return <span className='flex-container-row switch-container' style={small ? smallContainerStyle : containerStyle} onClick={onClick}>
              <span style={small ? smallSwitchStype : switchStype}></span>
           </span>
  }


}

export default Switch
